<template>
  <div :class="{ 'pb-button-block': true, full }">
    <button
      :class="{ 'pb-button': true, [size]: true, [color]: true, ghost }"
      :disabeld="disabeld ? true : false"
      :style="stylus"
      @click="$emit('click')"
    >
      <slot />
    </button>
  </div>
</template>

<script>
import { stylus } from "@/lib/utils";

export default {
  name: "PbButton",
  props: {
    type: {
      type: String,
      default: () => "button"
    },
    className: {
      type: String,
      default: () => ""
    },
    size: {
      type: String,
      default: () => "default"
    },
    color: {
      type: String,
      default: () => "disabled"
    },
    full: Boolean,
    disabeld: Boolean,
    ghost: Boolean,
    width: String
  },
  computed: {
    stylus() {
      return stylus({
        width: this.width
      });
    }
  },
  methods: {}
};
</script>

<style lang="scss">
@import "~styles/color";

.pb-button-block {
  display: inline-block;

  &.full {
    width: 100%;

    .pb-button {
      width: 100%;
    }
  }
}

.pb-button {
  min-width: 80px;
  color: #ffffff;
  background-color: $black;
  border: 1px solid #ffffff;
  border-radius: 5px;
  padding: 0 2.15rem;
  cursor: pointer;
  outline: none;

  &.small {
    font-size: 1.25rem;
    height: 42px;
    line-height: 42px;
  }

  &.large {
    font-size: 1.6rem;
    height: 48px;
    line-height: 48px;
  }

  &.default {
    font-size: 1.4rem;
    height: 44px;
    line-height: 44px;
  }

  &:disabled {
    @extend %disabled_setting;
  }

  &.black-reverse {
    border: 1px solid $black;
    color: $black;
    background-color: #ffffff;
  }

  &.error {
    @extend %error_setting;
  }

  &.success {
    @extend %success_setting;
  }

  &.info {
    @extend %info_setting;
  }

  &.warn {
    @extend %warn_setting;
  }

  &.primary {
    @extend %primary_setting;
  }

  &.ghost {
    background-color: transparent !important;
    color: #242424 !important;
    border: none;
  }
}
</style>
